export const API_URL = "https://front-test-api.herokuapp.com";
export const CACHE_TIME = 60 * 60 * 1000; // 1 hour
